module.exports = __webpack_public_path__ + "img/header_bg.a80f780d.png";